import React from 'react'
import Table from '../../../common/components/Table';
import PropTypes from 'prop-types'
import DateLabel from 'common/components/DateLabel';

const config = window.voucherManagementConfig.ui;

function voucherTableRow(onItemRemove, onItemEdit, t) {

  return (row) => {
    return (
      <tr key={row.uuid}>
        <td>{t('common:boolean.' + row.active)}</td>
        <td style={{maxWidth:'15vw', overflowWrap:'break-word'}}>{row.name.fi}</td>
        <td style={{maxWidth:'17vw', overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: row.description.fi }}></td>
        <td>{row.tags.join(' ')}</td>
        <td><DateLabel timestamp={row.validity.validSince} /></td>
        <td><DateLabel timestamp={row.validity.validUntil} /></td>
        <td>{row.validity.maxUseCount}</td>
        <td style={{ backgroundImage: `url(${row.logoUrl})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}>
        </td>
        <td><a onClick={() => onItemEdit(row)} className="badge rounded-pill fs-6 bg-primary"><i className="fas fa-pencil-alt"></i></a>
        </td>
        <td><span className="badge rounded-pill fs-6 bg-primary pill-button" onClick={() => onItemRemove(row)}><i className="far fa-trash-alt"></i></span>
        </td>
      </tr>
    )
  }
}

const VoucherTable = ({ t, data, onItemRemove, onItemEdit }) => {
  const columnTitles = [
    'voucher.active',
    'voucher.name',
    'voucher.description',
    'voucher.tags',
    'voucher.validFrom',
    'voucher.validTo',
    'voucher.maxUseCount',
    'voucher.logo',
    '',
    '',
  ].map(key => t(key));

  return (
    <Table t={t} columnTitles={columnTitles} rows={data} renderRow={voucherTableRow(onItemRemove, onItemEdit, t)} />
  );
};

VoucherTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onItemRemove: PropTypes.func,
  onItemEdit: PropTypes.func,
}

export default VoucherTable;
